import { createSlice } from "@reduxjs/toolkit";
import { numbers, slider, smsApp } from "../api/Download";


const initialState = {
   download : [],
   num : [],
   slider:[],
   isLoadingSlider:false,
   isLoadingNumber:false,
   isLoadingSms :false
}
export const DownloadSlice = createSlice({
    name:'download',
    initialState,
   
    extraReducers:{
        [smsApp.pending]:(state,{payload}) =>{  
            return {
                ...state,
                isLoadingSms :true,
                download:[]


            }
        },
        [smsApp.fulfilled]:(state,{payload}) =>{  
            return {
                ...state,
                isLoadingSms :false,
                download:payload


            }
        },
      
        [numbers.pending]:(state,{payload}) => {  
            return{
                ...state,
                isLoadingNumber:true,
                num:[]
            }
        },
        [numbers.fulfilled]:(state,{payload}) =>{  
            return{
                ...state,
                isLoadingNumber:false,
                num:payload
            }
        },
        [slider.pending]:(state,{payload}) =>{  
            return{
                ...state,
                isLoadingSlider:true,
                slider:[]
            }
        },
        [slider.fulfilled]:(state,{payload}) =>{  
            return{
                ...state,
                isLoadingSlider:false,
                slider:payload
            }
        }
     
    }
})


export default DownloadSlice.reducer